import { isLargeScreen } from './cssUtils';

export function getWindowHeight() {
    return window.innerHeight ? window.innerHeight : $(window).height();
}

export function getSiteMenuHeight() {
    const headerHeight = $(".js-global-header-wrap").outerHeight();

    return (getWindowHeight() - headerHeight);
}

export function isSiteMenuOpen() {
    return $('html').hasClass('has-site-menu-open');
}

/**
 * Get new header elements. This is needed because headerElement and offset
 * element get replaced in the DOM. Without re-fetching them the references
 * would point to old elements that no longer exist
 */
export function getCurrentHeaderElems() {
    return {
        headerElement: $('.js-global-header-wrap'),
        offSetElement: $('.js-global-promo-container')
    };
}

/**
 * Add fixed header class if scrolled past offset element
 * @param {string} fixedHeaderClass
 * @param {string} unPinnedHeaderClass
 */
export function showFixedHeaderIfScrolledPastOffset(fixedHeaderClass, unPinnedHeaderClass) {
    const { headerElement, offSetElement } = getCurrentHeaderElems();
    let scrollOffset = offSetElement.length ? offSetElement.outerHeight() : 0;
    let currentScrollPosition = $(window).scrollTop();
    let hasScrolledPastOffset = currentScrollPosition >= scrollOffset;

    headerElement.removeClass(unPinnedHeaderClass);
    headerElement.toggleClass(fixedHeaderClass, hasScrolledPastOffset);
}

/**
 * Add/remove fixed header class based on scroll position
 * @param {string} fixedHeaderClass
 * @param {string} unPinnedHeaderClass
 */
export function updateFixedHeaderOnScroll(fixedHeaderClass, unPinnedHeaderClass) {
    const disableTransitionClass = 'has-disabled-transition';

    const { headerElement, offSetElement } = getCurrentHeaderElems();
    const headerHeight = headerElement.outerHeight();
    let scrollOffset = offSetElement.length ? offSetElement.outerHeight() : 0;
    let isFirstScrollEvent = true;
    let headerBreakpoint = scrollOffset + headerHeight;
    let lastScrollPosition = $(window).scrollTop();

    // Ensure if no global promo is visible, the header is fixed on load
    if (!scrollOffset) {
        headerElement.addClass(fixedHeaderClass);
    }

    $(window).scroll(_.debounce(function headerDebounceOnWindowScroll() {
        // cancel all action if side nav is open
        if (isSiteMenuOpen()) {
            return;
        }

        scrollOffset = offSetElement.length ? offSetElement.outerHeight() : 0;
        let currentScrollPosition = $(window).scrollTop();
        let isScrollingDown = currentScrollPosition > lastScrollPosition;
        let hasScrolledPastOffset = currentScrollPosition > scrollOffset;

        if (!isLargeScreen($(window).width())) {
            // Adding the fixed header class by default for page load when the promo exists.
            // In some browsers a scroll event is tiriggered on page load if you are not at the top of the page.
            if (isFirstScrollEvent) {
                isFirstScrollEvent = false;
                lastScrollPosition = currentScrollPosition;
                if (currentScrollPosition >= 0) {
                    showFixedHeaderIfScrolledPastOffset(fixedHeaderClass, unPinnedHeaderClass);
                }
                return;
            }

            // Prevent Scroll events above top of page
            if (currentScrollPosition < 0) {
                lastScrollPosition = currentScrollPosition;
                return;
            }

            if (scrollOffset) {
                // Disable css transistion temporarily if scrolled from the top of page past header breakpoint in < 30ms
                if (lastScrollPosition < headerBreakpoint && currentScrollPosition > headerBreakpoint) {
                    headerElement.addClass(disableTransitionClass);
                } else if (!isScrollingDown) {
                    headerElement.removeClass(disableTransitionClass);
                }

                // If Promo banner exists, toggle position fixed class
                headerElement.toggleClass(fixedHeaderClass, hasScrolledPastOffset);
            }

            // Animating the header out of the viewport when you scroll downwards, and have passed the header breakpoint
            headerElement.toggleClass(unPinnedHeaderClass, isScrollingDown && currentScrollPosition > headerBreakpoint);
        } else if (scrollOffset) {
            // Toggle fixed header class for L-XL if promo banner exists, else fixed header class added in core-header.j2
            headerElement.toggleClass(fixedHeaderClass, hasScrolledPastOffset);
        }

        lastScrollPosition = currentScrollPosition;
    }, 30));
}

/**
 * Add/remove fixed header class based on resize event
 * @param {string} fixedHeaderClass
 * @param {string} unPinnedHeaderClass
 */
export function updateFixedHeaderOnResize(fixedHeaderClass, unPinnedHeaderClass) {
    let windowWidth = $(window).width();

    // Showing header when screen is resized horizontally
    $(window).resize(_.debounce(() => {
        // cancel all action if side nav is open
        if (isSiteMenuOpen() || windowWidth === $(window).width()) {
            return;
        }
        windowWidth = $(window).width();
        showFixedHeaderIfScrolledPastOffset(fixedHeaderClass, unPinnedHeaderClass);
    }, 500));
}

/**
 * Initialize adding/removing fixed header class for header and optionally add event updating
 * @param {bool} updateEvents optionally add update events for scroll and resize
 */
export function setupFixedHeader(updateEvents = false) {
    const { headerElement, offSetElement } = getCurrentHeaderElems();
    const fixedHeaderClass = 'c-global-header-wrap--fixed';
    const unPinnedHeaderClass = 'is-unpinned';

    showFixedHeaderIfScrolledPastOffset(fixedHeaderClass, unPinnedHeaderClass);

    if (updateEvents) {
        updateFixedHeaderOnScroll(fixedHeaderClass, unPinnedHeaderClass);
        updateFixedHeaderOnResize(fixedHeaderClass, unPinnedHeaderClass);
    }
}

/**
 * Check the document to see if PWA header is in use
 * @returns {boolean} has the PWA header class
 */
export function usingPwaHeader() {
    return Boolean(document.getElementsByClassName('js-pwa-site-header')[0]);
}
